import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import edit from "../../images/edit.svg";
import Delete from "../../images/delete.svg";
import Logo from "../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { EditUserData } from "./adminComp/userEditModal";

function EmailLogs({ adminType }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfUser, setnoOfUser] = useState(0);
  const [loader, setLoader] = useState(true);
  const [searchMail, setSearchMail] = useState("");
  const [resetPage, setResetPage] = useState(false);

  const [selectedData, setSelectedData] = useState({});

  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = (item) => {
    setSelectedData(item);
    setShowEdit(true);
  };

  // console.log(window.location);
  // console.log(match.url);
  const getUsers = async () => {
    try {
      let payload = {
        page: page,
      };
      setLoader(true);
      const userData = await api.getEmailLogs(payload);
      console.log(userData);
      setData(userData.logs);
      setnoOfUser(userData.count);
      setLimit(userData.limit);
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  const handleSearch = async () => {
    if (searchMail) {
      let payload = {
        query: searchMail,
      };
      const res = await api.searchEmailLogs(payload);
      // console.log(res);
      if (res?.success) {
        setData(res?.logs);
        setLimit(res?.logs?.length || 10);
        setnoOfUser(res?.logs?.length || 0);
      } else {
        alert("Invalid Email Address");
      }
    } else {
      alert("Please insert email for search");
    }
  };

  useEffect(() => {
    getUsers();
  }, [page, resetPage]);

  const handleReset = () => {
    setResetPage(!resetPage);
    setPage(1);
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid payHistoryPage">
        {/* Content Row */}
        <div className="row">
          {/* Area Chart */}
          <div className="col">
            <div className="row mx-0 drivers-row">
              <div className="col-12   d-flex justify-content-between ai-center pr-0 flex-wrap">
                <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                  Email Logs ({noOfUser})
                </h4>
                {/* <a href="#" className="driver-row-link">All</a>
                                 <a href="#" className="driver-row-link">Arbitrators (86)</a>
                                 <a href="#" className="driver-row-link">Mediators (32)</a> */}
                <div className="searchMadmin">
                  <div className="inputM">
                    <div className="iM">
                      <i className="fa-solid fa-magnifying-glass"></i>
                      <input
                        onChange={(e) => setSearchMail(e.target.value)}
                        type="text"
                        placeholder="Search by To/Subject..."
                      />
                    </div>
                    <i
                      className="fa-solid fa-magnifying-glass sIcon"
                      onClick={handleSearch}
                    ></i>
                  </div>
                  <button className="reset" onClick={() => handleReset()}>
                    <i className="fa-solid fa-arrow-rotate-right"></i>
                    Reset
                  </button>
                </div>
              </div>
            </div>
            {/* table */}
            <Table
              data={data}
              setPage={setPage}
              page={page}
              noOfUser={noOfUser}
              limit={limit}
              adminType={adminType}
              handleShowEdit={handleShowEdit}
            />
          </div>
        </div>

        <Modal
          show={showEdit}
          size="lg"
          onHide={handleCloseEdit}
          centered
          className=""
        >
          <Modal.Body>
            <div className="otpModalMain">
              <div className="closeIcon" onClick={handleCloseEdit}>
                <i className="fa-solid fa-xmark" />
              </div>
              <EditUserData
                getUsers={getUsers}
                setShow={setShowEdit}
                selectedData={selectedData}
              />
            </div>
          </Modal.Body>
        </Modal>
      </div>
      {/* /.container-fluid */}
      {loader && <Loader />}
    </>
  );
}
const Table = ({ data, page, setPage, noOfUser, limit }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const checkSubscription = (nextPayment) => {
    let currentDate = new Date();
    let endDate = new Date(nextPayment);

    if (currentDate < endDate) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    Send At
                  </th>
                  <th scope="col" className="">
                    To
                  </th>
                  <th scope="col" className="">
                    Subject
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {formatDate(item?.createdAt)}
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {item?.title}
                      </div>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.subject}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-center">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfUser / limit)}
                page={page}
                onChange={handleChange}
              />
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailLogs;
